import { canonicalMagPeriod } from './kkpMagPeriodUtils';

const STORAGE_KEY = 'kkp_cdf_mag_filters';

/**
 * @returns {{ annee: number, mois: number } | null}
 */
export function loadCdfMagFilters() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed.annee === 'number' && typeof parsed.mois === 'number') {
        return canonicalMagPeriod(parsed.annee, parsed.mois);
      }
    }
  } catch {
    // ignore
  }

  return null;
}

export function saveCdfMagFilters({ annee, mois }) {
  try {
    const period = canonicalMagPeriod(annee, mois);
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      annee: period.annee,
      mois: period.mois,
    }));
  } catch {
    // ignore
  }
}
